export const categories = [
  { name: 'authorization-provided', description: 'Authorization Provided' },
  { name: 'subpoena-to-be-prepared', description: 'Subpoena to be prepared by EXL' },
  { name: 'authorization-not-provided', description: 'Authorization not provided - EXL to obtain' },
  { name: 'subpoena-provided', description: 'Subpoena provided' }
];
  
  export const levels = [
    { name: 'Normal', value: 'Normal' },
    { name: 'Rush', value: 'Rush ' }
  ];
  
  export const titles = [
    { title: 'Attorney', value: 'attorney' },
    { title: 'Paralegal', value: 'Paralegal' },
    { title: 'Other', value: 'Other' }
  ];
  
  export const billers = [
    { name: 'Walmart', value: 'Walmart' },
    { name: 'B1', value: 'B1' },
    { name: 'B2', value: 'B1' },
    { name: 'B3', value: 'B1' }
  ];
  
  export const states = [
    { name: 'California', value: 'CA' },
    { name: 'Texas', value: 'TX' },
    { name: 'Florida', value: 'FL' },
    { name: 'New Jersey', value: 'NJ' }
  ];
  
  export const attachmentLabels = [
    { name: 'Authorization', value: 'Authorization' },
    { name: 'Subpoena', value: 'Subpoena' },
    { name: 'POA', value: 'POA' },
    { name: 'LOR', value: 'LOR' },
    { name: 'Other', value: 'OTH' }
  ];
  
  export const categoriesInExpectedOrder = [
    "authorization-provided",
    "subpoena-to-be-prepared",
    "authorization-not-provided",
    "subpoena-provided"
  ];

  export interface State {
    name: string;
    value: string;
  }
  
  export interface Category {
    name: string;
    description: string;
  }
  
  export interface Level {
    name: string;
    value: string;
  }
  
  export interface ContactTitle {
    title: string;
    value: string;
  }
  
  export interface Contact {
    contactTitle: ContactTitle;
    contactBarNo: string | null;
    contactName?: string;
    contactPhone?: number;
    contactPhoneExtn?: string;
    contactEmail?: string;
  }
  
  export interface OrderInfo {
    orderInfoRefNum: string;
    orderInfoDate: string;
    selectedCategory: Category;
    selectedLevel: Level;
    orderInfoBillToEmail: string;
    orderInfoBillingContactName: string;
    orderInfoAttentionTo: string;
    orderInfoAttentionToFirmName: string;
    orderInfoAttentionToFirmPhone: string;
    orderInfoAttentionToFirmPhoneExtn: number;
    orderInfoAttentionToFirmAddress: string;
    orderInfoAttentionToFirmCity: string;
    orderInfoAttentionToFirmState: State;
    orderInfoAttentionToFirmZip: string;
    orderInfoAttachmentFile: any; // Assuming file can be null or any other type
    orderInfoAttachmentLabel: any; // Assuming it can be null or any type
    orderInfoAttachmentExplanation: any; // Assuming it can be null or any type
    orderInfoSpecialInstructions: string;
    contacts: Contact[];
  }
  